import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_PROMOTION } from '@/modules/promotion/router';
import { promotionService } from '@/services/promotion';
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function usePromotionItemEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        name: '',
        image: null,
        imageStatus: null,
        imageFile: null
    });

    const validations = {
        name: { required },
        imageFile: {}
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => promotionService.item.get(model.id),
        onSuccess: ({ data }) => {
            model.id = data.id;
            model.name = data.name;
            model.image = data.image;
            model.imageStatus = data.imageStatus;
        },
        onError: () => router.push({ name: ROUTE_NAME_PROMOTION.ITEM.INDEX })
    });

    const update = crudAction.excuteAndNotify({
        validator: v$,
        request: () => promotionService.item.update(model.id, model.name, model.imageFile),
        onSuccess: () => {
            fetch();
            v$.value.$reset();
        }
    });

    return { model, v$, fetch, update };
}
